/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect, useCallback } from 'react';
import Style from './RastreadoresParceriasV2.css';
import Container from '../../atoms/Container';

function RastreadoresParceriasV2() {
  return (
    <>
      <section id="rastreadores-parcerias">
        <div className="box-parcerias">
          <div className="ctn">
            <div className="container-parcerias">
              <div className="parcerias-div-1">
                <div className="div-1-images">
                  <img className="logo-ituran" src="assets/rastreadores/ituran-v2.svg" alt="" />
                  <div className="div-carros-parcerias">
                    <img className="carro-1" src="assets/rastreadores/car-1-v2.png" alt="" />
                    <img className="carro-2" src="assets/rastreadores/car-2-v2.png" alt="" />
                  </div>
                </div>
                <div className="div-1-texts">
                  <h2 className="title">Conheça nossa parceira</h2>
                  <p className="description">
                    A <b className="font-18">Ituran</b> oferece serviços de proteção contra roubos e
                    furtos de veículos, cargas e frotas, utilizando uma <b>tecnologia avançada</b>{' '}
                    de rastreamento. Por isso, conte com a empresa líder no mercado de rastreamento
                    e recuperação de crédito.
                  </p>
                </div>
              </div>
              <div className="parcerias-div-2">
                <h3 className="div-2-title">Contatos e horários de funcionamento:</h3>
                <div className="div-2-card-ctns">
                  <div className="div-2-card">
                    <p className="card-title">Contatos:</p>
                    <ul className="card-list">
                      <li className="card-item">E-mail: atendimento.financeira@ituran.com.br</li>
                      <li className="card-item">Telefone: 0800 750 0038</li>
                      <li className="card-item">Whatsapp: (11) 3616-9086</li>
                    </ul>
                  </div>
                  <div className="div-2-card card-duas-linhas">
                    <p className="card-title">Atendimento:</p>
                    <ul className="card-list">
                      <li className="card-item">Segunda à sexta: 08hrs às 18hrs.</li>
                      <li className="card-item">Sábado: 08hrs às 14hrs.</li>
                    </ul>
                  </div>
                  <div className="div-2-card card-duas-linhas">
                    <p className="card-title">Instalação:</p>
                    <ul className="card-list">
                      <li className="card-item">Segunda à sexta: 08hrs às 18hrs.</li>
                      <li className="card-item">Sábado: 08hrs às 15hrs.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span className="background-parcerias" />
        <span className="bolinhas-parcerias" />
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default RastreadoresParceriasV2;
